<template>
    <div class="table-responsive" v-if="tableData">
        <table-editable-list 
            :columns="columns"
            :show-select="false"
            :show-actions="showActions"
            :show-columns = 'columns'
        >
            <template slot="data-row">
                <template v-for="( item, itemIdx ) in tableData">
                    <table-list-row
                        :key="item.id ? `${ storeKey }-${ item.id }` : `${ storeKey }-${ itemIdx }`"
                        :columns='columns'
                        :rowdata='item'
                        :rowIndex='itemIdx'
                        :show-columns='columns'				
                    >
                        <template v-for="column in columns">
                            <template :slot="column.customCol" v-if="column.customCol">
                                <slot :name="'pt' + column.customCol" :item="item"></slot>
                            </template>
                        </template>
                        
                        <template slot="actions" v-if="showActions">
                            <td class="td-actions">
                                <actions-button
                                    :button-index="itemIdx"
                                    :menu="actionsMenu"
                                    :data-struct="item"
                                    :rootURL="entrypoint">

                                    <template v-for="menu in actionsMenu">
                                        <template :slot="menu.aSlot" v-if="menu.aSlot">
                                            <slot :name="'pt' + menu.aSlot" :item="item"></slot>
                                        </template>
                                    </template>

                                </actions-button>
                            </td>
                        </template>
                    </table-list-row>
                </template>
            </template>
        </table-editable-list>
    </div>
</template>
<script>
import { mapState } from "vuex";

export default {
     props: {
        endpoint: String,
        entrypoint: String,
        storeKey:{
            type: String,
            required: false,
            default: 'tableData'
        },
        initialFilters: {
            type: Object,
            default: function () {
                return {}
            }
        },
        initialData: {
            required: false 
        },
        showActions: {
            type: Boolean,
            default: false
        }
     },
     data() {
         return {
             isLoading: false,
             filterBy : {},
             selectedColumns : []
         }
     },
     computed: {
        ...mapState( {
            globalStore : 'global',
            tableData( state ){
                return this.initialData ? this.$options.filters.denormalize( this.initialData ) : this.$options.filters.denormalize( state.global[ this.storeKey ] ) ;
            },
            columns( state ){
                return state.global[ this.storeKey + 'Settings' ] ? state.global[ this.storeKey + 'Settings' ].gridColumns : [] ;
            },
            actionsMenu( state ){
                return state.global[ this.storeKey + 'Settings' ] ? state.global[ this.storeKey + 'Settings' ].actionsMenu : [] ;
            }
        } )
    },
    created() {
        for ( var key in this.initialFilters ) {
            this.filterBy[ key ] = this.initialFilters[ key ];
        }
        
        this.fetchSettings();
        if( !this.initialData ){
            this.fetchTableData();
        }
    },
    methods: {
        fetchSettings() {
            this.$store.dispatch( 'fetch', {
                key : this.storeKey + 'Settings',
                href: this.endpoint + '/settings'
            })
        },
        fetchTableData() {
            this.$store.dispatch( 'fetch', {
                key : this.storeKey,
                href: this.endpoint,
                data: this.filterBy
            })
        }
    }
}
</script>